import React, { useContext } from 'react';
import { WindowSizeContext } from '/src/App';
import './style.css';

const StandardButton = ({ text, link, id, onClick }) => {
    const { deviceType } = useContext(WindowSizeContext);

    const handleLinkClickScrollToTop = () => {
        // Find the scrollable container (content-wrapper) instead of using window AFTER 1 second
        setTimeout(() => {
            const scrollContainer = document.querySelector('.content-wrapper');
            if (scrollContainer) {
                scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                // Fallback to window if content-wrapper doesn't exist
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }, 1000);
        return ;
    }

    return (
        <>
            {onClick && (
                <button
                    key={id}
                    onClick={onClick}
                    className={`standard-button ${deviceType}`}
                >
                    {text}
                </button>
            )}
            {link && (
                <a
                    key={id}
                    href={link}
                    onClick={handleLinkClickScrollToTop}
                    className={`standard-button ${deviceType}`}
                >
                    {text}
                </a>

            )}
        </>
    );
};

export default StandardButton;